module.exports = {"casino":{"je_ne_possede_pas_encore_de_compte":"Je ne possède pas encore de compte","demande_de_sav_refusees":"Demande de SAV refusées","numero_de_demande":"Numéro de demande","date_demande":"Date demande","date_d_achat":"Date d'achat","ean":"EAN","commentaire":"Commentaire","justificatif_d_achat":"Justificatif d'achat","plaque_signaletique":"Plaque signalétique","modifier":"Modifier","supprimer":"Supprimer"}}


//////////////////
// WEBPACK FOOTER
// ./src/companies/casino/lang/fr/home/home.lang.json
// module id = MxWT
// module chunks = 1